"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = __importDefault(require("../../client"));
const path = '/event';
function createEvent(auth, name, rounds, season, course, tee, start, end) {
    var _a;
    const data = {
        name,
        rounds,
        season,
        course,
        tee,
        start: start.toJSON().substring(0, 10),
        end: (_a = end === null || end === void 0 ? void 0 : end.toJSON().substring(0, 10)) !== null && _a !== void 0 ? _a : undefined,
    };
    if (data.end === undefined) {
        delete data.end;
    }
    return client_1.default.post(path, data, {
        headers: {
            Authorization: auth,
        },
    });
}
exports.default = createEvent;
